import Middleware from './Middleware'
export default class SyncPartnerRoute extends Middleware {
	/**
	 * Handle the incoming route change.
	 *
	 * @param {Object} to
	 * @param {Object} from
	 * @param {Function} next
	 * @return {void}
	 */
	handle(to, from, next) {
		if (this.isGuest()) {
			return next()
		}

		const routePartnerId = this.parseRoutePartnerId(to)

		if (!routePartnerId) {
			return next()
		}

		const activePartnerId = this.app.store.state.partners?.active

		if (routePartnerId === activePartnerId) {
			return next()
		}

		this.app.store
			.dispatch('partners/setActive', routePartnerId)
			.then(() => next())
			.catch(() =>
				this.redirectToActivePartner(to, activePartnerId, next)
			)
	}

	/**
	 * Redirect navigation back to the current active partner in the URL.
	 *
	 * @param {Object} to
	 * @param {Number|null} activePartnerId
	 * @param {Function} next
	 * @return {void}
	 */
	redirectToActivePartner(to, activePartnerId, next) {
		if (!activePartnerId) {
			return next()
		}

		next({
			name: to.name,
			params: {
				...to.params,
				partner: activePartnerId,
			},
			query: to.query,
			hash: to.hash,
		})
	}

	/**
	 * Parse the partner id from the route params.
	 *
	 * @param {Object} to
	 * @return {Number|null}
	 */
	parseRoutePartnerId(to) {
		const id = parseInt(to.params?.partner, 10)

		return Number.isNaN(id) ? null : id
	}

	/**
	 * Determine if the current user is a guest (not authenticated).
	 *
	 * @return {Boolean}
	 */
	isGuest() {
		const auth = this.app.use('App/Auth/Auth')

		return auth.isGuest()
	}
}
